import { useRouter } from 'expo-router';
import { SourceName } from 'features/application/hooks/useApplicationTrackErrorEvents';
import { useStepStartedFocusAnalytics } from 'features/application/hooks/useStepStartedFocusAnalytics';
import useSubmitApplication from 'features/application/hooks/useSubmitApplication';
import useUpdateApplication from 'features/application/hooks/useUpdateApplication';
import LegalAgreements from 'features/application/screens/LegalAgreements/LegalAgreements';
import useReactivationPrefillData from 'features/reactivation/hooks/useReactivationPrefillData';
import React from 'react';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';

const LegalAgreementsWrapper = () => {
  const router = useRouter();
  const {
    prefillDataFetching,
    prefillDataError,
    refetch: reExecuteQuery,
    reactivationApplicationId,
  } = useReactivationPrefillData();
  const {
    updateApplication,
    updateApplicationResult,
    isUpdateApplicationLoading,
  } = useUpdateApplication({
    applicationId: reactivationApplicationId,
    sourceName: SourceName.REACTIVATION_LEGAL_AGREEMENTS,
  });
  const {
    isSubmitApplicationSuccess,
    isSubmitApplicationLoading,
    submitApplicationMutationResult,
    submitApplicationErrorMessage,
    submitApplication,
  } = useSubmitApplication({
    applicationId: reactivationApplicationId,
    sourceName: SourceName.REACTIVATION_LEGAL_AGREEMENTS,
  });

  useViewDidFocusScreenAnalyticsEvent({
    key: 'legal-agreements-reactivation',
    customAttributes: {
      reactivation_flow: 'true',
      reactivation_id: reactivationApplicationId,
    },
  });

  useStepStartedFocusAnalytics({
    analyticsId: 'legalAgreementsStepStarted',
    customAttributes: {
      step_name: 'legal_agreements',
      reactivation_flow: 'true',
      reactivation_id: reactivationApplicationId,
    },
  });

  return (
    <LegalAgreements
      isSubmitApplicationSuccess={isSubmitApplicationSuccess}
      applicationId={reactivationApplicationId}
      updateApplication={updateApplication}
      updateApplicationResult={updateApplicationResult}
      isUpdateApplicationLoading={isUpdateApplicationLoading}
      onTryAgain={() => {
        if (prefillDataError as Error) {
          reExecuteQuery();
        } else if (submitApplicationErrorMessage) {
          // Submission failed, go back to review page and let them retry
          router.replace('/reactivation/review-info');
        }
      }}
      fetching={prefillDataFetching}
      error={(prefillDataError as Error) || submitApplicationErrorMessage}
      isReapplication={false}
      hasApplicationLoaded={!!reactivationApplicationId}
      isSubmitApplicationLoading={isSubmitApplicationLoading}
      submitApplication={submitApplication}
      submitApplicationMutationResult={submitApplicationMutationResult}
      backRoute="/reactivation/review-info"
      isReactivation
    />
  );
};

export default LegalAgreementsWrapper;
